import React from 'react';

interface TableRowProps {
  color?: string;
  borderColor?: string;
  children: React.ReactNode;
}

const TableRow = ({ ...props }: TableRowProps) => {
  return (
    <div
      className="flex justify-between items-center border-b px-4 py-2"
      style={{
        backgroundColor: props.color,
        borderColor: props.borderColor,
      }}
    >
      {props.children}
    </div>
  );
};

export default TableRow;
